import { render, staticRenderFns } from "./Digital_cultural_detail.vue?vue&type=template&id=44ccabc9&scoped=true&"
import script from "./Digital_cultural_detail.vue?vue&type=script&lang=js&"
export * from "./Digital_cultural_detail.vue?vue&type=script&lang=js&"
import style0 from "./Digital_cultural_detail.vue?vue&type=style&index=0&id=44ccabc9&lang=scss&scoped=true&"
import style1 from "./Digital_cultural_detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ccabc9",
  null
  
)

export default component.exports